<template>
  <div class="home">
    <Nav :visible="navVisible"></Nav>
    <div
      class="scroll-container-vertical"
      :style="{height:scrollVerticalHeight,marginLeft:scrollVerticalMarginLeft}"
    >
      <div class="scroll-container-horizontal">
        <div
          class="scroll-container"
          :style="{transform:`translate3d(${-scrollHeight}px,0px,0px)`}"
        >
          <main ref="scrollContainerHorizontal">
            <section class="first_section">
              <P1 />
            </section>
            <section id="p2">
              <P2 />
            </section>
            <section id="datePlan">
              <Date619 />
            </section>
            <section>
              <Date620 />
            </section>
            <section>
              <Date621 />
            </section>
            <section id="concat">
              <P3 />
            </section>
          </main>
        </div>
      </div>
    </div>
    <div class="video_wrapper" id="geekpark_video_iframe_wrapper" style="display:none;">
      <div class="innner_yellow_border" />
      <div class="innner_black_bg" />
      <iframe
        id="geekpark_video_iframe"
        style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;"
        src="//player.bilibili.com/player.html?aid=371093773&bvid=BV1zZ4y1H7tZ&cid=203266270&page=1&high_quality=1&danmaku=0"
        frameborder="no"
        scrolling="no"
      ></iframe>
      <img
        alt="关闭视频"
        class="close_video_btn"
        src="https://summit-img.geekpark.net/r2020/close_video_btn.svg"
        @click="closeVideo"
      />
    </div>
  </div>
</template>

<script>
import Nav from "@/components/pc/Nav.vue";
import P1 from "@/components/pc/P1.vue";
import P2 from "@/components/pc/P2.vue";
import P3 from "@/components/pc/P3.vue";
import Date619 from "@/components/pc/Date_619.vue";
import Date620 from "@/components/pc/Date_620.vue";
import Date621 from "@/components/pc/Date_621.vue";

export default {
  name: "HomePC",
  components: {
    Nav,
    P1,
    P2,
    P3,
    Date619,
    Date620,
    Date621,
  },
  data() {
    return {
      scrollVerticalHeight: "4000px",
      scrollVerticalMarginLeft: "0px",
      scrollHeight: 0,
      timer: null,
      navVisible: true,
    };
  },
  created() {
    window.onload = () => this.setClientSize();
    window.addEventListener("scroll", this.handleScroll, false);
    window.addEventListener("resize", this.setClientSize, false);
  },
  mounted() {
    this.timer = setTimeout(() => {
      const images = document.querySelectorAll("img");
      for (let i = 0; i < images.length; i++) {
        if (!images[i].complete) {
          return;
        }
      }
      this.setClientSize();
    }, 100);
    window.history.scrollRestoration &&
      (window.history.scrollRestoration = "manual");
    const links = document.querySelectorAll(".navs-container > .nav_item_link");
    for (let i = 0, { length } = links; i < length; i++) {
      links[i].addEventListener("click", function (e) {
        e.preventDefault();
        const href = this.getAttribute("href");
        if (href && href.startsWith("#")) {
          window.scrollTo({
            behavior: "smooth",
            top:
              document.querySelector(href).offsetLeft -
              document.querySelector("#nav").offsetWidth,
          });
        } else {
          window.open(href, "_blank");
        }
        return false;
      });
    }
  },
  methods: {
    setClientSize(flag) {
      const CLIENT_WIDTH = document.body.clientWidth;
      const CLIENT_HEIGHT = document.body.clientHeight;
      this.computeScrollVerticalHeight(CLIENT_WIDTH, CLIENT_HEIGHT);
    },
    computeScrollVerticalHeight(CLIENT_WIDTH, CLIENT_HEIGHT) {
      this.scrollVerticalHeight = `${
        this.$refs.scrollContainerHorizontal.offsetWidth -
        CLIENT_WIDTH +
        CLIENT_HEIGHT
      }px`;
    },
    handleScroll() {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const scrollInstance = scrollHeight - this.scrollHeight;
      this.scrollHeight = scrollHeight;
      if (this.scrollHeight <= 0) {
        this.navVisible = true;
        document
          .querySelector("#nav_last_rebuild_list")
          .classList.remove("last_rebuild_list_none");
        this.scrollVerticalMarginLeft = `${
          document.querySelector("#nav").offsetWidth
        }px`;
        return;
      }
      if (scrollInstance < 0) {
        this.navVisible = true;
        document
          .querySelector("#nav_last_rebuild_list")
          .classList.remove("last_rebuild_list_none");
        this.scrollVerticalMarginLeft = `${
          document.querySelector("#nav").offsetWidth
        }px`;
      } else {
        document
          .querySelector("#nav_last_rebuild_list")
          .classList.add("last_rebuild_list_none");
        this.navVisible = false;
        this.scrollVerticalMarginLeft = "0px";
      }
    },
    closeVideo() {
      const vIframeWrapper = document.getElementById(
        "geekpark_video_iframe_wrapper"
      );
      const vIframe = document.getElementById("geekpark_video_iframe");
      vIframeWrapper.style.display = "none";
      vIframe.src = "";
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.setClientSize);
    clearTimeout(this.timer);
  },
};
</script>

<style scoped lang="less">
.home {
  position: relative;
  height: 100vh;
}

.ticket {
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.5);
  }
}

.scroll-container-vertical {
  overflow-scrolling: touch;
}

.scroll-container-horizontal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.scroll-container {
  height: 100vh;
  align-self: flex-end;
}

main {
  display: flex;
  position: relative;
}

.first_section {
  padding-left: 8.5vh;
}

section {
  height: 100vh;
}

.video_wrapper {
  position: fixed;
  padding: 20% 31%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #000;
  z-index: 99999;
  .close_video_btn {
    position: absolute;
    top: -16px;
    right: -16px;
    height: 36px;
    width: auto;
    z-index: 99;
    &:hover {
      cursor: pointer;
    }
  }
  .innner_black_bg {
    background: #000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .innner_yellow_border {
    content: " ";
    display: block;
    width: 100%;
    height: 100%;
    background: #faf04e;
    border: 1px solid #000;
    position: absolute;
    bottom: -0.5vw;
    right: -0.5vw;
  }
}
</style>
